/**
 * @author Yaochao
 * @date 2021/8/6 14:06
 * @description
 */
import React from 'react'
import {Redirect, Route} from "react-router-dom";
import loadable from "../../loadable";

const RedeemCodeManage = loadable(() => import('./redeemcode_manage'));
const RedeemCodeData = loadable(() => import('./redeemcode_data'));
const RedeemCodeCreate = loadable(() => import('./redeemcode_create'));

class RedeemCodeRouter extends React.Component {

    render() {
        return (
            <>
                <Route exact path={this.props.match.url + '/'}
                       render={() => (<Redirect to={this.props.match.url + "/manage"}/>)}
                />
                <Route path={this.props.match.url + "/manage"} component={RedeemCodeManage}/>
                <Route path={this.props.match.url + "/data/:id"} component={RedeemCodeData}/>
                <Route path={this.props.match.url + "/create"} component={RedeemCodeCreate}/>
            </>
        )
    }
}

export default RedeemCodeRouter